<template>
  <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-30" v-if="isOpen">
    <div class="absolute w-full h-full bg-gray-900 opacity-50" @click="close"></div>

    <div class="absolute w-full bottom-0 sm:inset-y-auto overflow-x-hidden max-w-3xl">
      <div class="bg-white flex flex-col max-h-screen py-4" style="border-radius: 10px">
        <div
          class="flex justify-between items-center mb-5 px-5 pb-4 border-b border-gray-200 shrink-0"
        >
          <div class="font-semibold text-xl text-gray-600 pr-7">Detail</div>
          <img :src="SvgClear" class="cursor-pointer" @click="close" />
        </div>

        <div class="flex-1 overflow-y-auto">
          <div v-html="isOpen.description" class="px-5"></div>

          <div class="mt-3 px-5">
            <div class="news-detail">
              <agile
                :options="carouselOptions"
                @after-change="e => (currentIndex = e.currentSlide)"
              >
                <div
                  v-for="(item, index) in isOpen.file_url"
                  :key="index"
                  style="height: 10rem"
                  class="slide relative cursor-pointer"
                  @click="MODAL_NEWS(item)"
                >
                  <div class="mt-2 rounded-lg h-6">
                    <img
                      v-if="item.file_type == 'image'"
                      :src="item.file_path"
                      class="rounded-lg cursor-pointer"
                    />
                    <video v-else :src="item.file_path" controls class="rounded-lg"></video>
                  </div>
                </div>
              </agile>
            </div>
          </div>

          <div class="flex items-center justify-between space-x-2 mt-4 px-5">
            <div class="flex items-center space-x-5">
              <div class="flex items-center space-x-2">
                <IconLike
                  @click="toLiked"
                  class="h-6 w-6 cursor-pointer"
                  :class="isOpen.is_like ? 'text-blue-500' : 'text-gray-400'"
                />
                <span class="text-gray-600 font-medium">{{ isOpen.likes_count }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <IconComment class="h-6 w-6 text-gray-400" />
                <span class="text-gray-600 font-medium">{{ isOpen.comments_count }}</span>
              </div>
            </div>

            <div class="flex items-center space-x-4 overflow-x-auto">
              <div class="text-gray-00 font-medium">
                {{ isOpen.published_at | moment('DD MMM YYYY') }}
              </div>
              <div class="rounded px-1.5 py-0.5 font-semibold bg-gray-100 text-gray-600">
                {{ isOpen.category_name }}
              </div>
            </div>
          </div>

          <div class="mt-3 flex flex-col px-5">
            <div class="font-semibold">Komentar</div>

            <div class="flex flex-col mt-2 space-y-4">
              <div v-for="item in comments" :key="item.id">
                <div class="flex items-center space-x-1.5">
                  <IconProfile class="h-8 w-8 text-gray-400" />
                  <div class="flex flex-col">
                    <div class="font-medium text-sm">{{ item.user_name }}</div>
                    <div class="text-gray-500 text-13px">{{ item.client_name }}</div>
                  </div>
                </div>
                <div class="mt-1.5 bg-gray-50 rounded-xl px-3 py-1">
                  <div class="text-gray-800" v-html="item.comment"></div>
                  <div class="text-gray-500 text-13px mt-0.5">
                    {{ item.created_at | moment('MMM DD, YYYY') }}
                  </div>
                </div>
              </div>
            </div>

            <button
              v-if="comments.length > 0 && page < lastPage"
              @click="loadMore"
              class="text-blue-500 text-sm font-medium px-3 py-1 rounded-lg bg-blue-50 w-fit mx-auto mt-5 hover:bg-blue-100"
            >
              Load more
            </button>

            <div v-if="!comments.length" class="flex flex-col items-center justify-center py-5">
              <IconNoComment class="h-18 w-22" />
              <span class="text-gray-500">No comments yet</span>
            </div>
          </div>

          <div class="mt-5 border-t border-gray-200 px-5 pt-5 pb-1.5" v-if="isOpen.allow_comment">
            <div class="flex items-start space-x-3 bg-blue-50 rounded-xl p-2.5">
              <textarea
                class="flex-1 bg-blue-50 outline-none"
                placeholder="Write your comment here...!"
                rows="3"
                v-model="comment"
              ></textarea>
              <button
                :disabled="!comment || loadingComment"
                @click="sendComment"
                class="bg-blue-500 text-white px-2.5 font-semibold py-1 rounded-lg hover:bg-blue-700"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgClear from '@/assets/icons/icon-close.svg'

import WaveBack from '@/assets/images/wave-back.png'
import WaveFront from '@/assets/images/wave-front.png'
import IconComment from '@/assets/icons/icon-comment.svg?inline'
import IconLike from '@/assets/icons/icon-like.svg?inline'
import IconProfile from '@/assets/icons/icon-profile.svg?inline'
import IconNoComment from '@/assets/icons/icon-nocomment.svg?inline'

import { mapActions } from 'vuex'
import {
  sosmedCommentIndex,
  sosmedCommentStore,
  sosmedPostLiked,
  sosmedPostDetail
} from '@/services/apiSosmed'

export default {
  name: 'news-detail',
  components: {
    IconComment,
    IconLike,
    IconProfile,
    IconNoComment
  },
  data() {
    return {
      SvgClear,
      WaveBack,
      WaveFront,
      loading: false,
      loadingComment: false,
      comments: [],
      comment: '',
      page: 1,
      lastPage: 1,
      countLike: 0,
      carouselOptions: {
        slidesToShow: 1,
        centerMode: true,
        initialSlide: 0,
        autoplay: false,
        speed: 3000
      }
    }
  },
  methods: {
    ...mapActions('modal', ['MODAL_NEWS']),
    close() {
      this.MODAL_NEWS(false)
      this.loading = false
    },
    async getComment(id) {
      // TODO: Fetch comments from API
      this.loading = true
      let params = {
        post_id: id,
        page: this.page,
        per_page: 5
      }

      let res = await sosmedCommentIndex(params)
      if (res) {
        this.comments = res.data || []
        this.lastPage = res.meta.last_page || 1
      }
      this.loading = false
    },
    async sendComment() {
      if (!this.comment.trim()) return

      // TODO: Send comment to API
      this.loadingComment = true

      let res = await sosmedCommentStore({
        post_id: this.isOpen.id,
        comment: this.comment
      })
      // TODO: Implement comment sending logic
      this.loadingComment = false
      this.comment = ''

      if (res) {
        this.comments.unshift(res.data)
      }
    },
    async loadMore() {
      this.page++
      let params = {
        post_id: this.isOpen.id,
        page: this.page,
        per_page: 5
      }

      let res = await sosmedCommentIndex(params)

      if (res) {
        this.comments = [...this.comments, ...res.data]
        this.lastPage = res.meta.last_page || 1
      }
    },
    async toLiked() {
      if (this.countLike) return

      this.countLike = 1

      await sosmedPostLiked({
        post_id: this.isOpen.id
      })
      let res = await sosmedPostDetail(this.isOpen.id)
      if (res) {
        this.isOpen = res.data
      }

      setTimeout(() => {
        this.countLike = 0
      }, 3000)
    }
  },
  computed: {
    isOpen: {
      get: function () {
        return this.$store.state.modal.news
      },
      set: function (value) {
        this.MODAL_NEWS(value)
      }
    }
  },
  watch: {
    isOpen: {
      handler(val) {
        if (val && val.id) {
          this.getComment(val.id)
          this.page = 1
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
.news-detail .agile {
  @apply max-w-727 mx-auto;
  width: 100%;
  border-radius: 12px;
}
.news-detail .agile__nav-button {
  background: transparent;
  border: none;
  color: black;
  cursor: pointer;
  font-size: 24px;
  height: 100%;
  position: absolute;
  top: 0;
  transition-duration: 0.3s;
  width: 28px;
}

.news-detail .agile__nav-button:hover {
  background-color: #cfcfcf45;
  /* background-color: transparent; */
  opacity: 1;
}
.news-detail .agile__nav-button--prev {
  left: 0;
}
.news-detail .agile__nav-button--next {
  right: 0;
}

.news-detail .agile__list {
  height: 400px;
}

.news-detail .agile__actions {
  margin-top: 10px;
}

.news-detail .agile__dots {
  bottom: -10px;
  left: 45%;
  position: absolute;
}
.news-detail .agile__dot {
  margin: 0 4px;
}
.news-detail .agile__dot button {
  background-color: #cbcbcb;
  /* border: 1px solid #e1e1e1; */
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 11px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 11px;
}
.news-detail .agile__dot--current button,
.agile__dot:hover button {
  background-color: #0073be;
  width: 11px;
  border-radius: 50%;
}

.news-detail .slide {
  border-radius: 8px;
  width: 90%;
  height: 400px;
}
</style>
